import { EntryCollection } from 'contentful';
import { RichTextContent } from 'types/RichTextContent';

import { getEntries } from './ContentfulClient';

type ContentfulFaq = {
  order: number;
  question: string;
  isTitle: boolean;
  isBlurb: boolean;
  answer: RichTextContent;
};

const transformFaq = (faq: EntryCollection<ContentfulFaq>) => {
  return faq.items.map(({ fields }) => {
    const { order, isTitle, isBlurb, question, answer } = fields;

    return {
      order,
      isTitle,
      isBlurb,
      question,
      answer,
    };
  });
};

export const getAllFaq = async () => {
  return transformFaq(await getEntries<ContentfulFaq>('faq'));
};
